import { routes } from 'ogp/Routes';
import { useSearchParams } from 'react-router-dom';

const { queryParams } = routes.FlexPools;

export const useFlexPoolDetail = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const open = (id: string) => {
    setSearchParams(
      (searchParams) => {
        searchParams.set(queryParams.FLEXPOOL_ID, id);
        return searchParams;
      },
      {
        replace: true,
      }
    );
  };

  const close = () => {
    setSearchParams(
      (searchParams) => {
        searchParams.delete(queryParams.FLEXPOOL_ID);
        return searchParams;
      },
      {
        replace: true,
      }
    );
  };

  return { id: searchParams.get(queryParams.FLEXPOOL_ID), open, close };
};
